import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("craft_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const staffApi = axios.create({ baseURL: API });
staffApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("craft_staff_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const LOGO_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_34ec1318-5a53-4c84-808f-af155ab83ab3/artifacts/lroh2x6t_image.png";
